import type { AccountPageConfig } from './types'

export const DEFAULT_ACCOUNT_PAGE_CONFIG: AccountPageConfig = {
  layout: {
    background_color: '#FFFFFF',
    page_radius: '0px',
    side_margin: '10px',
  },
  navigation: {
    background_color: '#FFFFFF',
    primary_color: '#432E1A',
    text_color: '#000000',
    tab_radius: '10px',
    quick_links: [
      {
        label: 'dummy_label',
        url: 'dummy_url',
        enabled: true,
      },
    ],
  },
  pages: {
    profile: {
      details: {
        background_color: '#FFFFFF',
        text_color: '#000000',
        border_color: '#E5E5E5',
        card_radius: '8px',
        card_border: '1px',
        sides: 'all',
      },
      button: {
        background_color: '#000000',
        text_color: '#FFFFFF',
        border_radius: '10px',
        cta_label: 'Edit Profile',
      },
      saved_addresses: {
        header_color: '#E5E5E5',
        background_color: '#FFFFFF',
        border_color: '#E5E5E5',
        text_color: '#000000',
        card_radius: '8px',
        card_border: '1px',
        sides: 'all',
      },
    },
    orders: {
      action_bar: {
        header_color: '#000000',
        primary_color: '#000000',
        background_color: '#FFFFFF',
        tab_radius: '8px',
      },
      details: {
        group_header_color: '#000000',
        order_info_color: '#000000',
        background_color: '#FFFFFF',
        statuses: {
          delivered: { background_color: '#00A651', text_color: '#FFFFFF' },
          in_transit: { background_color: '#0066CC', text_color: '#FFFFFF' },
          refunded: { background_color: '#FFA500', text_color: '#FFFFFF' },
          cancelled: { background_color: '#FF0000', text_color: '#FFFFFF' },
        },
        card_radius: '8px',
        card_border: '1px',
        sides: 'all',
        button: {
          background_color: '#000000',
          text_color: '#FFFFFF',
        },
        border_color: '#000000',
        show_cancel_option: false,
        show_tracking_option: false,
      },
      quick_links: {
        text_color: '#000000',
        socials_color: '#000000',
        button: {
          background_color: '#000000',
          text_color: '#FFFFFF',
        },
        statuses: {
          delivered: { background_color: '#00A651', text_color: '#FFFFFF' },
          in_transit: { background_color: '#0066CC', text_color: '#FFFFFF' },
          refunded: { background_color: '#FF0000', text_color: '#FFFFFF' },
          cancelled: { background_color: '#FF0000', text_color: '#FFFFFF' },
        },
      },
    },
    rewards: {
      balance_card: {
        primary_color: '#000000',
        text_color: '#FFFFFF',
      },
      buttons: {
        primary_color: '#000000',
        button_radius: '10px',
        text_color: '#000000',
      },
      on_order_placement: {
        background_color: '#FFFFFF',
        primary_color: '#000000',
        text_color: '#000000',
        border_color: '#E5E5E5',
        card_radius: '8px',
        card_border: '1px',
        header_text: 'lorem Ipsum',
        sub_text: 'lorem Ipsum',
      },
      reward_history: {
        primary_color: '#000000',
        text_color: '#FFFFFF',
      },
    },
  },
}
